import React, { createContext } from "react";

export const CreateTodoContext = createContext();
